
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adinsertion",
      function () {
        return require("private-next-pages/adinsertion.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adinsertion"])
      });
    }
  